import classNames from 'classnames/bind';
import { gql } from '@apollo/client';
import styles from './AcfStats.module.scss';
import { Grid, Heading } from '@/components';
import { useState, useEffect, useRef } from 'react';

let cx = classNames.bind(styles);

const delay = 4000;

export default function AcfStats(props) {
	const { statsModule, attributes } = props;
	const className = attributes.className?.split(' ') || [];
	const statsCount = statsModule.stats?.length;

	const [shownStat, setShownStat] = useState(0);
	const timeoutRef = useRef(null);

	function resetTimeout() {
    if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}
	}

	useEffect(() => {
    const runCycle = () => {
      if (window.innerWidth < 821) {
        resetTimeout();
				timeoutRef.current = setTimeout(() => setShownStat((prevShownStat) => (prevShownStat === statsCount - 1) ? 0 : prevShownStat + 1), delay);
			} else {
				resetTimeout();
			}
		};
    runCycle();
		window.addEventListener('resize', runCycle);
		return () => {
      window.removeEventListener('resize', runCycle);
			resetTimeout();
    };
	}, [shownStat]);

	function Stat({ stat, index }) {
		return (
			<div className={cx(['ns_stat', 'stat', index === shownStat && 'show'])} >
				{statsModule.element === 'p' ? (
					<p>
						<span className={cx(['ns_stat-num', 'stat_num'])} dangerouslySetInnerHTML={{ __html: stat.number ?? '' }} />
						<span className={cx(['ns_stat-desc', 'stat_desc'])} dangerouslySetInnerHTML={{ __html: stat.description ?? '' }} />
					</p>
				) : (
					<Heading level={statsModule.element}>
						<span className={cx(['ns_stat-num', 'stat_num'])} dangerouslySetInnerHTML={{ __html: stat.number ?? '' }} />
						<span className={cx(['ns_stat-desc', 'stat_desc'])} dangerouslySetInnerHTML={{ __html: stat.description ?? '' }} />
					</Heading>
				)}
			</div>
		);
	}

	return (
		<>
			<div id={attributes.anchor} className={cx(['ns_stats', 'stats', ...className])}>
				<Grid colCount={statsCount > 4 ? 4 : statsCount}>
					{statsModule.stats.map((stat, index) => (
						<Stat stat={stat} index={index} key={index} />
					))}
				</Grid>
			</div>
		</>
	);
}

AcfStats.fragments = {
	key: `AcfStatsFragment`,
	entry: gql`
		fragment AcfStatsFragment on AcfStats {
			attributes {
        anchor
				className
			}
			statsModule {
				element
				stats {
					description
					number
				}
			}
		}
	`,
};

AcfStats.config = {
	name: 'AcfStats',
};
AcfStats.displayName = 'AcfStats';
